"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "36", height: "28", viewBox: "0 0 36 28", className: "Icon toolbar-image-preview", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("path", { d: "M0 0h36v28H0z" }),
            _react2.default.createElement("path", { fill: "#E3E3E3", d: "M0 0h36v28H0z" }),
            _react2.default.createElement("path", { fill: "#4C4C4C", d: "M12 12l12 16H0z" }),
            _react2.default.createElement("path", { fill: "#4C4C4C", d: "M28.5 19l7.5 9H21z" }),
            _react2.default.createElement("path", { d: "M27 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6z", fill: "#FFF" }),
            _react2.default.createElement("path", { stroke: "#BBB", d: "M.5.5h35v27H.5z" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/toolbar-image-preview.js
// module id = 1841
// module chunks = 0